import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import MyMenuOrdersAction from "../../../components/User/MyMenuOrdersComponents/MyMenuOrdersActions";
import MyMenuOrdersTable from "../../../components/User/MyMenuOrdersComponents/MyMenuOrdersTable";

const { getRestaurants } = appActions;

const MyMenuOrders = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Справка MyMenu поръчки" date={true} />
      <MyMenuOrdersAction />
      <MyMenuOrdersTable />
    </div>
  );
};

export default MyMenuOrders;
